import React from 'react';

import { observable } from 'mobx';

import BaseStore from 'bz-stores/mobx/base-store';

import { DMARCWarningRequest } from 'tm3-core/api.dtos';

export interface IState {
  acknowledged: boolean;
}

const useEmailWarningState = (onError?: (e: unknown) => void): IState => {
  React.useDebugValue('useEmailWarningState');

  return React.useState<IState>(() => {
    const state = observable({
      acknowledged: true
    });

    BaseStore.defaultClient.get(new DMARCWarningRequest()).then((res) => {
      state.acknowledged = res.result;
    }, onError);

    return state;
  })[0];
};

export default useEmailWarningState;
